import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает сохраненный ранее тип просмотра листинга
 */
export const selectFavoriteListingType = ({ settings: { favoriteListingType } }: IApplicationState) =>
  favoriteListingType;
